import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  labelCheck: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 0',
    fontSize: '14px',
    color: 'rgba(39, 58, 57, 0.8)',
  },
  labelGroup: {
    width: '140px',
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
  },
}));